import SvgIcon from "components/base/SvgIcon";

import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "components/ui/tooltip";
import { SearchContext, JobsContext } from "context/providers";
import { useContext, useMemo } from "react";

const noAIReasoningFoundString = `No AI Reasoning Found (this is common with saved searches created in previous versions, resetting skills usually fixes this)`;

function ReasoningTooltip() {
  const { searchState } = useContext(SearchContext);
  const { jobOpp } = useContext(JobsContext);

  const { skills } = searchState;

  const reasoning = skills?.reasoning;
  const aiSkills = skills?.aiSkills;

  const rehypedTooltip = useMemo(() => {
    if (!reasoning) {
      return noAIReasoningFoundString;
    }
    if (!aiSkills) return reasoning;

    const aiSkillNames = aiSkills
      .map((skill) => {
        return skill.name;
      })
      .sort((a, b) => b.length - a.length);

    const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const skillRegex = new RegExp(
      `\\b(${aiSkillNames.map(escapeRegex).join("|")})\\b`,
      "g"
    );

    const highlightedReasoning = reasoning.replace(skillRegex, (match) => {
      return `<span class="text-sky-600 font-bold">${match}</span>`;
    });
    return highlightedReasoning;
  }, [reasoning, aiSkills]);

  if (!jobOpp) return null;

  return (
    <TooltipProvider>
      <Tooltip id="ai-reasoning">
        <TooltipTrigger
          id="ai-reasoning-trigger"
          className="flex gap-1 items-center text-base text-sky-600 hover:text-sky-700 font-bold"
        >
          <SvgIcon type={"aiSparkles"} /> AI Reasoning
        </TooltipTrigger>
        <TooltipContent className="max-w-xl">
          <div
            id="ai-reasoning-content"
            className="flex flex-col gap-3 p-4 text-slate-800"
          >
            <p className="text-lg">
              👩 Hi, I'm Olivia! Let me tell you why I chose these terms for the
              <span className="font-bold"> {jobOpp.title}</span> job
              opportunity:{" "}
            </p>
            <p dangerouslySetInnerHTML={{ __html: rehypedTooltip }} />
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default ReasoningTooltip;
